<template>
	<div class="question-list ">
		<endTime :endtime="user.endDate"></endTime>
		<div class="Q-content">
			<p class="top-title">
				{{ info.questionnaireText }}
				<el-switch style="margin: 0px 0 0 10px;" v-model="info.visibility" active-text="公开"
					:disabled="switchLoading" inactive-text="不公开" @change="switchChange">
				</el-switch>
			</p>
			<div class="num-right">
				<p v-if="radio1 == '按指标填写'" class="num">答题：{{ finishNum1 }}/{{ allNum1 }}</p>
				<p v-else class="num">答题：{{ finishNum2 }}/{{ allNum2 }}</p>
				<div class="right-tab">
					<el-radio-group @input="radio1Chage" v-model="radio1">
						<el-radio-button label="按指标填写"></el-radio-button>
						<el-radio-button label="按部门填写"></el-radio-button>
					</el-radio-group>
				</div>
			</div>
			<div v-if="radio1 == '按指标填写'">
				<IndexQuestions :questionsList="defaultQuestion" :infoId="info.id" @dataUpdated="getDefaultQuestion"
					@distribution="Distribution" @allCheck1="allCheck1" />
			</div>
			<div v-else>
				<el-button class="top-btn" type="primary" @click="open">创建新部门</el-button>
				<DeparentmentQuestions :questionsList="userDefinedQuestion" :infoId="info.id" @updateName="updateName"
					@deleteDepartment="deleteDepartment" @dataUpdated="getUserDefinedQuestion" @allCheck2="allCheck2"
					@distribution="Distribution" />
			</div>
			<el-button class="submit-btn" @click="totalSubmit">提交</el-button>
		</div>

		<el-dialog title="分配部门" :visible.sync="DepartmentData.visible" width="500px">
			<div class="dialog-input">
				<el-input placeholder="创建新的部门" v-model="DepartmentData.newName"></el-input>
				<el-button class="d-i-btn" type="primary" :disabled="DepartmentData.newName == ''"
					@click="buildNew">创建</el-button>
			</div>
			<div class="dialog-con">
				<p class="d-c-title">全部</p>
				<p v-if="DepartmentData.list.length == 0" class="d-c-noList">暂无创建部门</p>
				<div class="d-c-ul">
					<div class="d-c-u-item" v-for="(item, index) in DepartmentData.list" :key="'radio' + index">
						<el-radio v-model="DepartmentData.chooseName" :label="item.id">{{ item.classifyName }}</el-radio>
						<span @click="updateName(item)" class="d-c-u-i-update">修改名称</span>
						<span @click="deleteDepartment(item.id)" class="d-c-u-i-delete">删除</span>
					</div>
				</div>
			</div>

			<span slot="footer" class="dialog-footer">
				<el-button @click="DepartmentData.visible = false">取 消</el-button>
				<el-button type="primary" :disabled="DepartmentData.chooseName == ''" @click="enterDialog">确 定</el-button>
			</span>
		</el-dialog>
		<el-dialog title="部门名称" :visible.sync="DepartmentData.updataVisible" width="500px">
			<el-input placeholder="输入部门新名称" v-model="DepartmentData.updateName"></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="DepartmentData.updataVisible = false">取 消</el-button>
				<el-button type="primary" :disabled="DepartmentData.updateName == ''" @click="updateDialog">确 定</el-button>
			</span>
		</el-dialog>
		<span v-loading.fullscreen.lock="fullscreenLoading"></span>

	</div>
</template>

<script>
import Cookies from 'js-cookie';
import {
	questionApi
} from '../api/api-url/question.js'
import { autoFormApi } from '../api/api-url/autoForm';
import endTime from '../components/time.vue'
import DeparentmentQuestions from '../components/questionListComponents/departmentQuestions.vue'
import IndexQuestions from '../components/questionListComponents/indexQuestions.vue'
import store from '../store';
export default {
	name: 'QuestionList',
	components: {
		endTime,
		DeparentmentQuestions,
		IndexQuestions
	},
	data() {
		return {
			fullscreenLoading: false,
			user: {},
			info: {},
			radio1: '按指标填写',
			marginLeft: 0,
			tableData: [],
			defaultQuestion: [],//按指标分类
			allNum1: 0,
			finishNum1: 0,
			allNum2: 0,
			finishNum2: 0,
			// 分配部门相关数据
			DepartmentData: {
				list: [],//部门列表
				arr: [],//待分配部门的问题
				visible: false,//分配部门弹窗
				newName: '',//新建部门的名字
				updateId: '',//要修改的部门的id
				updataVisible: false,//修改部门名称的弹窗
				updateName: '',//修改部门时候的新名字
				chooseName: '',//选择部门的id
			},
			userDefinedQuestion: [],//按部门分类
			qusType: '',
			dimensionName: '',
			switchLoading: false,
		}
	},
	created() {
		// console.log(window.screen.width)
	},
	mounted() {
		this.marginLeft = (window.screen.width - 1000) / 2;
		this.getUserInfo()
		this.getUserDefinedQuestion()
		this.getDefaultQuestion()
		if (store.state.radio === 2) {
			this.radio1 = '按部门填写'
		}
	},
	methods: {
		// 获取用户信息和问卷信息
		async getUserInfo() {
			let res = await questionApi.selectUserInfo()
			// console.log(res)
			if (res.code == 1) {
				Cookies.set('companyName', res.result.user.companyName, {
					expires: 30
				})
				if (res.result.info != null) {
					this.info = res.result.info;
				}
				this.user = res.result.user;
			}
		},
		// 获取默认分类问卷信息（维度分类）
		async getDefaultQuestion() {
			this.fullscreenLoading = true
			let res = await questionApi.selectDefaultQuestion()
			if (res) {
				// console.log(res);
				this.allNum1 = res.result.total;
				this.finishNum1 = res.result.progress;
				const value = res.result.defaultList.map(item => {
					item.value = item.value.map(ite => {
						ite.checkList = [];
						ite.allChecked = false;
						return ite
					})
					return item
				});
				this.defaultQuestion = value
				// console.log(this.defaultQuestion);
				this.fullscreenLoading = false
			}
		},
		// 获取默认分类问卷信息（自定义分类）
		async getUserDefinedQuestion() {
			let res = await questionApi.selectUserDefinedQuestion()
			console.log(res)
			if (res) {
				this.allNum2 = res.result.total;
				this.finishNum2 = res.result.progress;
				this.userDefinedQuestion = res.result.userDefinedList.map(item => {
					item.checkList = [];
					item.allChecked = false;
					return item
				});
			}
		},
		// 切换按指标还是按部门展示
		radio1Chage(val) {
			if (val == '按指标填写') {
				store.commit('setRadio', 1)
				this.getDefaultQuestion()
			} else {
				store.commit('setRadio', 2)
				this.getUserDefinedQuestion()
			}
		},

		// 分配全选（维度分类）
		allCheck1(val, index, ind) {
			if (val) {
				this.defaultQuestion[index].value[ind].checkList = this.defaultQuestion[index].value[ind].value.map(item => {
					if (item.submitStatus == 0) {
						return item.id
					}
				})
			} else {
				this.defaultQuestion[index].value[ind].checkList = [];
			}
		},
		// 分配全选（自定义分类）
		allCheck2(val, index) {
			console.log(val, index);

			if (val) {
				this.userDefinedQuestion[index].checkList = this.userDefinedQuestion[index].value.map(item => {
					console.log(item.submitStatus);
					if (item.submitStatus == 0) {
						return item.id
					}
				})
			} else {
				this.userDefinedQuestion[index].checkList = [];
			}
		},
		//打开分配问题页面
		Distribution(arr) {
			this.getClassify();
			this.DepartmentData.arr = arr;
			this.DepartmentData.newName = '';
			this.DepartmentData.visible = true;
		},
		// 获取分类列表
		async getClassify() {
			let res = await questionApi.selectClassify({
				infoId: this.info.id
			})
			if (res) {
				this.DepartmentData.list = res.result.classifyList;
			}
		},
		// 创建新部门
		async buildNew() {
			let res = await questionApi.selectCreateClassify({
				infoId: this.info.id,
				classifyName: this.DepartmentData.newName
			})
			if (res.code === 1) {
				this.DepartmentData.newName = '';
				this.getClassify();
				this.getUserDefinedQuestion();
			}
		},
		// 修改部门名称
		updateName(item) {
			this.DepartmentData.updateId = item.id;
			this.DepartmentData.updateName = "";
			this.DepartmentData.updataVisible = true;
		},
		// 去数据库修改部门名称
		async updateDialog() {
			let res = await questionApi.selectUpdateClassify({
				id: this.DepartmentData.updateId,
				classifyName: this.DepartmentData.updateName
			})
			if (res) {
				this.getClassify();
				this.getUserDefinedQuestion();
				this.DepartmentData.updataVisible = false;
			}
		},
		// 删除部门
		async deleteDepartment(id) {
			this.$confirm('确认要删除部门吗？已分配给该部门的题目会回归到未分配部门的状态！', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(async () => {
				let res = await questionApi.selectDeleteClassify({
					id,
				})
				if (res) {
					this.DepartmentData.chooseName = '';
					this.getClassify();
					this.getUserDefinedQuestion();
				}
			})
		},
		// 确定分配部门
		async enterDialog() {
			let res = await questionApi.selectAllocationIssues({
				questionId: this.DepartmentData.arr.join(','),
				classifyId: this.DepartmentData.chooseName
			})
			if (res) {
				if (this.radio1 == '按指标填写') {
					this.getDefaultQuestion();
				} else {
					this.getUserDefinedQuestion();
				}
				this.DepartmentData.visible = false;
			}
		},
		//创建新部门
		open() {
			this.$prompt('请输入部门名称', '创建新部门', {
				distinguishCancelAndClose: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				inputValidator: value => {
					if (value == null || value === '') return "部门名称不能为空"
				},
			}).then(async ({ value }) => {
				let res = await questionApi.selectCreateClassify({
					infoId: this.info.id,
					classifyName: value
				})
				if (res.code === 1) {
					this.$message({
						type: 'success',
						message: `部门${value}创建成功`
					});
					this.getUserDefinedQuestion();
				}
			}).catch((action) => {
				if (action === 'cancel') {
					this.$message({
						type: 'info',
						message: '取消输入'
					});
				}
			});
		},
		async submitQuestionnaire() {
			const res = await questionApi.selectSubmitQuestionnaire({
				id: this.info.id
			})
			if (res) {
				console.log(res);
			}
		},
		//底部提交
		totalSubmit() {
			if (this.finishNum1 !== this.allNum1) {
				this.$alert('您的问题还没有填写完成，请完成所有题目后再提交', '提示', {
					confirmButtonText: '确定',
				});
				return
			}
			this.$confirm('确定提交吗?', '提示', {
				distinguishCancelAndClose: true,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.submitQuestionnaire()
				this.$message({
					type: 'success',
					message: `提交成功`
				});
				this.$router.push({
					name: 'CommitPage',
					query: {
						endTime: this.user.endDate,
						questionnaireText: this.info.questionnaireText
					}
				})
			}).catch((action) => {
				if (action === 'cancel') {
					this.$message({
						type: 'info',
						message: '已取消提交'
					});
				}
			});
		},
		async switchChange(val) {
			this.switchLoading = true
			const res = await autoFormApi.visibilityApi({
				id: this.info.id,
				type: 1,
				status: val
			})
			if (res.code === 1) {
				this.$message.success("状态修改成功！")
			}
			this.switchLoading = false
		},
	},
}
</script>

<style scoped lang="scss">
.question-list {
	padding-top: 20px;
	background-color: #fff;
	height: 100%;
	overflow-y: auto;

	.Q-content {
		width: 1000px;
		padding-bottom: 76px;
		margin: 0 auto;

		.top-title {
			text-align: center;
			font-size: 24px;
			color: #333333;
			font-weight: 700;
			margin-top: 30px;
			margin-bottom: 20px;
		}

		.num-right {
			position: relative;

			.num {
				line-height: 38px;
			}

			.right-tab {
				position: absolute;
				right: 0px;
				top: 5px;
			}
		}

		.top-btn {
			width: 150px;
			height: 48px;
			margin-top: 31px;
			margin-bottom: 5px;
		}

		.submit-btn {
			display: block;
			margin: 0 auto;
			width: 280px;
			height: 48px;
			background: #3B9395;
			border-radius: 2px;
			color: #fff;
		}

	}

	.dialog-input {
		position: relative;

		.d-i-btn {
			position: absolute;
			right: 0px;
			top: 0px;
		}
	}

	.d-c-title {
		font-size: 14px;
		color: #333;
		line-height: 44px;
	}

	.d-c-noList {
		color: #979797;
	}

	.d-c-ul {
		.d-c-u-item {
			height: 32px;
			position: relative;
			background-color: #fff;

			.el-radio {
				margin-top: 8px;
				margin-left: 10px;
			}

			.d-c-u-i-update {
				color: #3B9395;
				border-bottom: 1px solid #3B9395;
				cursor: pointer;
				margin-left: 10px;
			}

			.d-c-u-i-delete {
				color: #FF3B3B;
				border-bottom: 1px solid #FF3B3B;
				cursor: pointer;
				margin-left: 10px;
			}
		}
	}
}
</style>